;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "jDnL7CA5uW"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
    function loadGoogleMaps() {
        if(section.settings.map_api != ''){
            if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                var mapScript = document.createElement('script');
                mapScript.src = "https://maps.googleapis.com/maps/api/js?key=" + section.settings.map_api;
                document.head.appendChild(mapScript);
            }
        }
    }

    loadGoogleMaps();

    function initMap() {
          var myLatLng = {
            lat: parseFloat(section.settings.map_lat),
            lng: parseFloat(section.settings.map_lng)
          };

          var map = new google.maps.Map(document.getElementById('map'), {
            zoom: parseInt(section.settings.map_zoom),
            center: myLatLng,
          });

          var infoString = '<div class="lh-infowindow">'+ section.settings.map_info_box +'</div>';

          var infowindow = new google.maps.InfoWindow({
            content: infoString
          });

          var iconMarker = 'https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/cJaU316XBS458Mm0/contact/assets/images/mapker.svg';
          if(section.settings.map_marker != ''){
            iconMarker = section.settings.map_marker;
          }

          var markerArgs = {
            position: myLatLng,
            map: map,
            icon: iconMarker,
            visible: true
          };

          if(section.settings.map_show_marker == 'no'){
            markerArgs.visible = false;
          }

          var marker = new google.maps.Marker(markerArgs);

          if(section.settings.map_style == 'style_2'){
            var customStyled = [{"elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.local","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#e9fefd"},{"saturation":-35},{"lightness":10},{"weight":1.5}]}];
            map.set('styles', customStyled);
          }
          if(section.settings.map_style == 'style_3'){
            var customStyled = [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#6e6e6e"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f4f4f4"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"all","stylers":[{"visibility":"simplified"},{"color":"#d2ef9d"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#94dfed"},{"visibility":"on"}]}];
            map.set('styles', customStyled);
          }

          if(section.settings.map_show_marker == 'yes'){
            marker.addListener('click', function() {
                infowindow.open(map, marker);
            });
          }

          if(section.settings.map_show_infobox == 'yes' || (section.settings.map_show_marker == 'no' && section.settings.map_show_infobox == 'yes')){
              google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                infowindow.open(map, marker);
              });
          }

          if(section.settings.map_show_marker == 'no' && section.settings.map_show_infobox == 'yes'){
              google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                  $('.lh-google-map-section').addClass('lh-hide-close-infobox');
              });
          }

          return map;
    }

    var timerLoadMap = setInterval(funcCheckLoadMap, 50);

    function funcCheckLoadMap(){
        if (typeof google === 'object' && typeof google.maps === 'object') {
            initMap();
            clearInterval(timerLoadMap);
        }
    }
 };						cb.bind($('section[data-section-id="jDnL7CA5uW"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="jDnL7CA5uW"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/cJaU316XBS458Mm0/contact/",						settings: {"map_api":"AIzaSyBQ9aDYSjvqxNerYONWqGCJovVRfK3kZYU","map_lat":"-37.7593756","map_lng":"144.9574408","map_zoom":"14","map_info_box":"<p style=\"margin-bottom:5px\"><strong>Flexikitch Head Office</strong></p><p style=\"margin-bottom:5px\">45-49 Tinning St Brunswick</p><p style=\"margin-bottom:5px\"><a href=\"mailto:info@flexikitch.com.au\">info@flexikitch.com.au</a></p><p>1300 769 161</p><!--lh-live-editor-->","map_marker":"https://cdn.shopify.com/s/files/1/0609/9543/6701/t/2/assets/flexikitch-logo-sym_axvG.png?v=1655961073","map_show_marker":"yes","map_style":"style_1","map_show_infobox":"no"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "VWPCT461ue"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="VWPCT461ue"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/cJaU316XBS458Mm0/services/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');